var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"chevron","fillRule":"evenodd","clipRule":"evenodd","d":"M9.79496 14.2597C10.4146 13.54 10.8731 12.9936 11.1706 12.6204C12.9056 10.5574 14.3269 8.92309 15.4346 7.71744C16.5424 6.51179 17.8303 5.23916 19.2983 3.89955L19.2983 0.644287L16.0552 0.644287C8.66217 0.644287 7.28231 0.644287 3.24298 0.644286L-0.000120163 0.644286L-0.000120305 3.89954C1.46795 5.23916 2.75585 6.51179 3.86357 7.71744C4.9713 8.92309 6.39266 10.5574 8.12765 12.6204C8.44796 13.0223 8.95511 13.6251 9.64911 14.4289L9.79496 14.2597Z","fill":"black"}));
}

ChevronInline.defaultProps = {"width":"20","height":"15","viewBox":"0 0 20 15","fill":"none"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
